import Swiper, { Navigation } from 'swiper'
import { getBreakpointValue } from '../helpers'

const largeCardsSliderContainerEls = document.querySelectorAll('.large-cards-slider')
const desktopColWidth = window.innerWidth / 9
largeCardsSliderContainerEls.forEach((sliderContainer) => {
    const largeCardsSwiperEl = sliderContainer.querySelector('.large-cards-slider__swiper-el')
    const largeCardsSwiperNavigationButtonNextEl = sliderContainer.querySelector(
        '.large-cards-slider__navigation button.swiper-button.next'
    )
    const largeCardsSwiperNavigationButtonPrevEl = sliderContainer.querySelector(
        '.large-cards-slider__navigation button.swiper-button.prev'
    )

    new Swiper(largeCardsSwiperEl, {
        modules: [Navigation],
        slidesPerView: 1.3335,
        spaceBetween: desktopColWidth,
        navigation: { nextEl: largeCardsSwiperNavigationButtonNextEl, prevEl: largeCardsSwiperNavigationButtonPrevEl },
        breakpoints: {
            [getBreakpointValue('lg')]: {
                slidesOffsetAfter: desktopColWidth * 2
            }
        }
    })
})
